"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));

var _CardMedia = _interopRequireDefault(require("@material-ui/core/CardMedia"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    avatar: {
      backgroundColor: theme.palette.primary.main
    },
    media: {
      paddingTop: '50%'
    }
  };
});

var ProductCardBody = function ProductCardBody(_ref) {
  var certificates = _ref.certificates,
      cover = _ref.cover,
      title = _ref.title,
      subheader = _ref.subheader;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, cover != null && /*#__PURE__*/_react["default"].createElement(_CardMedia["default"], {
    className: classes.media,
    image: cover.src,
    title: title
  }), /*#__PURE__*/_react["default"].createElement(_CardHeader["default"], {
    avatar: /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
      "aria-label": "Recipe",
      className: classes.avatar
    }, certificates.length > 99 ? '99+' : certificates.length),
    title: title,
    subheader: subheader
  }));
};

var _default = ProductCardBody;
exports["default"] = _default;